import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments';
import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular';
import { EnvName } from './environments/env-name.enum';

Sentry.init(
  {
    dsn: environment.sentryDsn,
    environment: environment.name,
    release: `mystaffler@${environment.appVersion}`,
    enabled: !!environment.sentryDsn && environment.name !== EnvName.DEV,
    sendDefaultPii: false,
  },
  SentryAngular.init
);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

defineCustomElements(window);
